<template>
    <div v-if="elementsLoaded" class="finishedProjects">
    <h2 v-if="elements.length > 0">Meine beendeten Aktionen</h2>
    <template v-for="(pair, index) in pairedElements">
        <div class="doubleTeaser">
            <div>
                <div class="card-deck-wrapper">
                    <div class="card-deck">
					    <template v-for="(element, innerIndex) in pair">
					        <div v-html="element.html" class="card"> </div>
					    </template>
					    <div v-if="pair.length < 2" class="card"></div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <button v-if="hasMoreInternal" class="btn btn-white teaserButton width100" style="margin-top:30px;" v-on:click="getElements">lade ältere aktionen</button>
    </div>
</template>

<script>
	export default {
		name: 'my-finished-projects-list',
		props: {
            elements: Array,
            hasMore: Boolean
        },
        data: function() {
        	return {
        		elementsLoaded: false,
        		hasMoreInternal: false
        	}
        },
        computed: {
        	pairedElements: function() {
        		return this.elements.reduce(function(result, value, index, array) {
        			  if (index % 2 === 0)
        			      result.push(array.slice(index, index + 2));
        			  return result;
        			}, []);
        	}        	
        },
        watch: {
        	hasMore: function(value) {
        		this.hasMoreInternal = value;
        	}
        },
        methods: {
        	getElementHtml: function(item) {
                jQuery.ajax ({
                    url: '/getMyProjectsElement/finished',
                    type: 'POST',
                    data: JSON.stringify(item),
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        item.html = data;
                    },
                    error: function() {console.log("error while loading element");}
                });
            },
            initElement: function(item, index) {
                item.html = '';
                this.getElementHtml(item);
            },
        	getElements: function() {
        		var caller = this;
                jQuery.ajax ({
                    url: '/getFinishedProjectsElements/' + caller.elements.length,
                    type: 'POST',
                    dataType: "json",
                    data: "",
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        var result = data;
                        result.elements.forEach(caller.initElement);
                        caller.elements.push.apply(caller.elements, result.elements);
                        caller.hasMoreInternal = result.hasMore;
                        caller.onElementsLoaded();
                    },
                    error: function() {console.log("error while loading elements");}
                });
            },
            onElementsLoaded: function() {
                this.$nextTick(function() {
                    this.elementsLoaded = true;
                });
            }
        }
	}
</script>


// WEBPACK FOOTER //
// MyFinishedProjectsList.vue?ac1b8b66